import { SVGProps } from 'react';

export const RangeOperatorLessThanOrEqual = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    width="10"
    height="15"
    viewBox="0 0 10 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 14.0098H9.91016V11.9688H0V14.0098ZM0.15625 4.02832V6.09082L9.54395 10.1299V7.60059L2.79883 5.04297L9.54395 2.53027V0L0.15625 4.02832Z"
      fill="currentColor"
    />
  </svg>
);
